import { useQuery } from "@tanstack/react-query";
import api from "@/lib/axios";
import {
  DailyTransportListRow,
  DailyTransportListSearchParams,
} from "@/interface/settlement/dailyTransport";

// 일일운송명세서 조회 (개별 전표 리스트)
export const useDailyTransportList = (
  params: DailyTransportListSearchParams & { page?: number; size?: number }
) => {
  return useQuery<{
    content: DailyTransportListRow[];
    totalElements: number;
    totalPages: number;
    last: boolean;
  }>({
    queryKey: ["dailyTransportList", params],
    queryFn: async () => {
      const { data } = await api.get("/daily-transport/list", {
        params: {
          startDate: params.startDate,
          endDate: params.endDate,
          company: params.company || "",
          searchType: params.searchType || "",
          search: params.search || "",
          exactMatch: params.exactMatch || false,
          itemSearchType: params.itemSearchType || "",
          itemSearch: params.itemSearch || "",
          page: params.page || 0,
          size: params.size || 1000,
        },
      });
      return data.data;
    },
    enabled: !!params.startDate && !!params.endDate,
  });
};
